import * as THREE from 'three';
import {
    Inputs
} from './lib/inputs';
import {
    PointerLockControls
} from './lib/PointerLockControls.js';
import {
    Session
} from './lib/session';
import {
    visualizeLog
} from "./lib/utils";
import './style.css';

let camera, renderer, controls;
let prevTime = performance.now();
let isTouch = false;

if (('ontouchstart' in window) || navigator && (navigator.maxTouchPoints > 0) || navigator && (navigator.msMaxTouchPoints > 0)) {
    isTouch = true;
}

const canvas = document.getElementById('webgl-canvas');
const scene = new THREE.Scene();
const session = new Session(scene, true, true);
const inputs = new Inputs(isTouch);


const playerMesh1 = new THREE.Mesh(
    new THREE.BoxGeometry(2, 20, 2).toNonIndexed(),
    new THREE.MeshBasicMaterial({
        color: 0xffffff,
    }),
);

const playerMesh2 = new THREE.Mesh(
    new THREE.BoxGeometry(2, 20, 2).toNonIndexed(),
    new THREE.MeshBasicMaterial({
        color: 0xffffff,
    }),
);

const playerMesh3 = new THREE.Mesh(
    new THREE.BoxGeometry(2, 20, 2).toNonIndexed(),
    new THREE.MeshBasicMaterial({
        color: 0xffffff,
    }),
);


playerMesh1.position.set(0, -10, 100)
playerMesh2.position.set(0, 10, -100)
playerMesh3.position.set(0, -10, -100)
scene.add(playerMesh1);
scene.add(playerMesh2);
scene.add(playerMesh3);

const init = () => {


    const textureLoader = new THREE.TextureLoader();
    const seaColorTexture = textureLoader.load('photo.jpg');
    const seaHeightTexture = textureLoader.load('photo.jpg');

    const material = new THREE.MeshStandardMaterial();
    material.roughness = 1;
    material.metalness = 0;
    material.displacementMap = seaHeightTexture;
    material.map = seaColorTexture;

    // material.wireframe = false;
    material.displacementScale = 50;
    material.transparent = true;
    const dimension = 50;
    const plane = new THREE.Mesh(new THREE.PlaneBufferGeometry(dimension, dimension * 1.33, 300, 300), material);
    plane.position.set(0, dimension - 10, -0.01);
    plane.rotation.y = -Math.PI;
    scene.add(plane);



    const material1 = new THREE.MeshBasicMaterial();
    material1.map = seaColorTexture;
    // material1.wireframe = false;
    material1.transparent = true;
    const plane1 = new THREE.Mesh(new THREE.PlaneBufferGeometry(dimension, dimension * 1.33, 1, 1), material1);
    plane1.position.set(0, dimension - 10, 0.01);
    scene.add(plane1);


    // camera
    camera = new THREE.PerspectiveCamera(75, window.innerWidth / (window.innerHeight), 1, 1000);
    camera.position.set(0, 10, 100)
    camera.lookAt(0, dimension / 3 * 2, 0);


    //light
    const light = new THREE.AmbientLight(0xeeeeff, 1);

    // add point light
    const pointLight = new THREE.PointLight(0xffffff, 1, 100);
    pointLight.position.set(0, 20, 0);
    scene.add(pointLight);
    scene.add(light);

    // sky
    const skyMaterial = new THREE.MeshBasicMaterial({
        color: 0xffffff,
        side: THREE.BackSide,
        wireframe: true
    });
    const skyboxGeo = new THREE.SphereGeometry(140, 30, 30).toNonIndexed();
    const skybox = new THREE.Mesh(skyboxGeo, skyMaterial);
    scene.add(skybox);

    const skyMaterial2 = new THREE.MeshBasicMaterial({
        color: 0x000000,
        side: THREE.BackSide,
    });
    const skyboxGeo2 = new THREE.SphereGeometry(140.1, 30, 30).toNonIndexed();
    const skybox2 = new THREE.Mesh(skyboxGeo2, skyMaterial2);
    scene.add(skybox2);

    // controls
    controls = new PointerLockControls(camera, canvas);
    scene.add(controls.getObject());

    canvas.addEventListener('click', () => {
        visualizeLog(`Click`);
        controls.lock()
    });

    // floor
    const floorGeometry = new THREE.PlaneGeometry(750, 750, 30, 30).toNonIndexed();
    floorGeometry.rotateX(-Math.PI / 2);

    const floorMaterial = new THREE.MeshBasicMaterial({
        color: '#ffffff',
        transparent: true,

        wireframe: false,
        side: THREE.DoubleSide,
        opacity: 0.15,
        roughness: 1,
    });

    const floorMaterialSpeculat = new THREE.MeshStandardMaterial({
        transparent: true,
        side: THREE.DoubleSide,
        opacity: 0.15,
        roughness: 1,
    });

    const floor = new THREE.Mesh(floorGeometry, floorMaterial);
    const floor2 = new THREE.Mesh(floorGeometry, floorMaterialSpeculat);
    scene.add(floor);
    scene.add(floor2);



    // const floorMaterialSpeculat2 = new THREE.MeshBasicMaterial({
    //     side: THREE.DoubleSide,
    //     color: 'rgb(38,38,38)',
    // });

    const floor3 = new THREE.Mesh(floorGeometry, floorMaterialSpeculat);
    const floor4 = new THREE.Mesh(floorGeometry, floorMaterial);

    floor3.rotation.x = Math.PI / 2;
    floor4.rotation.x = Math.PI / 2;
    scene.add(floor3);
    scene.add(floor4);



    // set up the renderer
    renderer = new THREE.WebGLRenderer({
        canvas: document.getElementById('webgl-canvas'),
        antialias: true,
    });

    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setSize(window.innerWidth, (window.innerHeight));
    renderer.setAnimationLoop(() => tick());
    window.addEventListener('resize', onWindowResize);
}

const onWindowResize = () => {
    camera.aspect = (window.innerWidth) / (window.innerHeight);
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, (window.innerHeight));
}

// calulate distance from origin
const distance = (x, z) => {
    return Math.sqrt(x * x + z * z);
}

const tick = () => {
    const time = performance.now();
    const position = controls.getObject().position;

    if (!controls.isLocked && !isTouch) {
        inputs.clear();
    }

    // time passed from previous frame
    const delta = (time - prevTime) / 1000;
    const speed = inputs.sprint ? 1.8 : 1;

    // movement deceleration
    inputs.velocity.x -= inputs.velocity.x * 10.0 * delta * (1 / speed);
    inputs.velocity.z -= inputs.velocity.z * 10.0 * delta * (1 / speed);

    // gravity
    inputs.velocity.y -= 1.62 * 100.0 * delta; // 100.0 = mass

    // current direction
    if (!isTouch) {
        inputs.direction.z = Number(inputs.moveForward) - Number(inputs.moveBackward);
        inputs.direction.x = Number(inputs.moveRight) - Number(inputs.moveLeft);
        inputs.direction.normalize(); // this ensures consistent movements in all directions
    }

    // calculate movement speed
    if (inputs.moveForward || inputs.moveBackward) inputs.velocity.z -= inputs.direction.z * 400.0 * delta;
    if (inputs.moveLeft || inputs.moveRight) inputs.velocity.x -= inputs.direction.x * 400.0 * delta;

    // update player position
    controls.moveRight(-inputs.velocity.x * delta);
    controls.moveForward(-inputs.velocity.z * delta);
    position.y += (inputs.velocity.y * delta); // new behavior

    // avoid falling through floor
    if (position.y < 10.1) {
        inputs.velocity.y = 0;
        position.y = 10.1;
        inputs.canJump = true;
    }

    // stop movement if distance is > 355
    if (distance(position.x, position.z) > 120) {
        controls.moveRight(inputs.velocity.x * delta);
        controls.moveForward(inputs.velocity.z * delta);
    }

    playerMesh1.position.set(position.x, -position.y, position.z);
    playerMesh2.position.set(position.x, position.y, -position.z);
    playerMesh3.position.set(position.x, -position.y, -position.z);

    playerMesh1.rotation.y = camera.rotation.z;
    playerMesh2.rotation.y = -camera.rotation.z;
    playerMesh3.rotation.y = -camera.rotation.z;

    session.sendPositionUpdate(position, camera.rotation.z);
    renderer.render(scene, camera);
    prevTime = time;
}

init();